import { render, staticRenderFns } from "./notes-list.vue?vue&type=template&id=622446ec&scoped=true"
import script from "./notes-list.vue?vue&type=script&lang=js"
export * from "./notes-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622446ec",
  null
  
)

export default component.exports